/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from 'react';
import './ChemicalCurve.scss';
import { Button, ButtonType, Heading, Icon, Size } from '@vaisala-rockhopper/components';
import { useTranslation } from 'react-i18next';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';
import { CurveData } from '../../../../modules/ChemicalDataController';
import CurveInformation from '../cards/CurveInformation';
import CurveParameterMatrix from '../cards/CurveParameterMatrix';
import CalculationCard from '../cards/CalculationCard';
import { isMobileOnly } from 'react-device-detect';

interface ChemicalCurveProps {
    selectedChemical: number
    selectedChemicalData: CurveData | null
    theme: string
    onChemicalChanged(id: number): void
}

const ChemicalCurve = ({ selectedChemical, selectedChemicalData, theme, onChemicalChanged }: ChemicalCurveProps) => {
  const { t } = useTranslation();

  const [curveInformation, setCurveInformation] = React.useState<CurveData | null>(null);

  React.useEffect(() => {
    setCurveInformation(selectedChemicalData)
  }, [selectedChemicalData])

  if (curveInformation) {
    return (
        <div className={`chemical-curve ${selectedChemical > -1 ? 'chemical-curve--active' : ''} `}>
          {!isMobileOnly &&
            <>
              <Button
                className={'back-button'}
                buttonType={ButtonType.Link}
                buttonSize={Size.S}
                startIcon={<Icon name={VaiIcon.ChevronLeft} size={Size.XL}/>}
                onClick={() => {
                  onChemicalChanged(-1);
                }}
              >
                {t('ui.change_curve')}
              </Button>
            </>
          }
            <CurveInformation
                curveInformation={curveInformation}
            />
            {curveInformation.Confidential &&
                <div className="confidential-alert">
                    <Heading level={3}><Icon name={VaiIcon.Warning} size={Size.L} />Confidential</Heading>
                </div>
            }
            <CalculationCard
                curveInformation={curveInformation}
                theme={theme}
            />
            <CurveParameterMatrix
                curveInformation={curveInformation}
            />
        </div>
      );
  } else return null;
};
export default ChemicalCurve;
